<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center ">
            <div class="flex align-center margin-right-sm ">
              <span>商品名称：</span>
              <el-input v-model="name" placeholder="请输入商品名称" class="flex-sub"></el-input>
            </div>
            <el-button type="primary" @click="hanldSearch">搜索</el-button>
          </div>
        </div>
<!--        <el-button type="primary" @click="editItem(0)">导出</el-button>-->
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
        </div>
      </div>

      <el-table
        :data="residentList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="商品名称" prop="product_name"></el-table-column>
        <el-table-column label="价格（积分）" prop="price"></el-table-column>
        <el-table-column label="兑换人" prop="name"></el-table-column>
        <el-table-column label="兑换人电话" prop="username"></el-table-column>
        <el-table-column label="兑换时间" prop="create_time"></el-table-column>

        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="table-operate" v-if="scope.row.state === 0">
              <el-button
                size="small"
                type="primary"
                @click="passItem(scope.row.id)"
              >确认收货
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delItem(scope.row.id)"
              >取消订单
              </el-button>
            </div>
            <div class="table-operate" v-if="scope.row.state === 1">兑换完成</div>
            <div class="table-operate" v-if="scope.row.state === 2">取消兑换</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="residentList.length > 0"
        class="page-all"
        background
        @current-change="getResidentList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {orderList, updateState} from "@/api/weilao";
export default {
  name: "order",
  data() {
    return {
      name: '',
      page: 1,
      limit: 10,
      total: 0,
      residentList: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/shopping', "双暖为老 / 订单管理", true);
    this.getResidentList()
  },
  methods: {
    //  商品确认收货
    passItem(id){
      this.$confirm('您确定要该订单已确认收货吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.surePass(id);
      });
    },
    async surePass(id) {
      let _state = await updateState(id,1);
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  商品取消订单
    delItem(id){
      this.$confirm('您确定要取消该商品订单吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await updateState(id,2);
      this.getResidentList();
      this.$message.success(_state.info);
    },

    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },
    //  获取商品列表
    async getResidentList() {
      let _data = await orderList(
        this.name,
        this.page,
        this.limit,
      )
      this.residentList = _data.data
      this.total = _data.total_number
    },

  },
  filters: {
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
